module.exports = __webpack_public_path__ + "img/accordion-arrow.e812bd5d.svg";